import { gql } from "@apollo/client"
import { EnrollTeamMemberInput, EnrollTeamMemberPayload } from "@oysterhr/schema"
import { useMutation } from "@oysterhr/core"

const ENROLL_TEAM_MEMBER_BENEFITS_QUERY = gql`
  mutation EnrollTeamMemberBenefits($input: EnrollTeamMemberInput!) {
    teamMemberEnrollBenefits(input: $input) {
      errors
    }
  }
`

export function useEnrollTeamMember() {
  return useMutation<
    {
      teamMemberEnrollBenefits: EnrollTeamMemberPayload
    },
    { input: EnrollTeamMemberInput }
  >(ENROLL_TEAM_MEMBER_BENEFITS_QUERY)
}
